import { BaseApi } from '../../api/apiBase';
import type { LivestreamViewer } from '../types/livestream.types';

class LivestreamViewerApi extends BaseApi {
  constructor() {
    super('/api/portal');
  }

  async getLivestreamViewer(eventSlug: string, livestreamId: string): Promise<LivestreamViewer> {
    return this.get<LivestreamViewer>(`/events/${eventSlug}/livestream_viewer/${livestreamId}`);
  }

  async checkIn(eventSlug: string, livestreamId: string): Promise<{ success: boolean; message: string }> {
    return this.post(`/events/${eventSlug}/livestream_viewer/${livestreamId}/check_in`);
  }
}

export const livestreamViewerApi = new LivestreamViewerApi();